import { Check, Minus, X } from 'lucide-react'
import { SonCta } from '../components/cta'
import { Reveal } from '../components/hareket'
import { Baslik, SayfaUstu, Section, cn } from '../components/ui'
import { SATIRLAR, SUTUNLAR, type Hucre } from '../icerik/karsilastirma'
import { useHead } from '../lib/head'

function HucreIkon({ v }: { v: Hucre }) {
  if (v === true) return <Check className="mx-auto size-4 text-success" aria-label="Var" />
  if (v === 'kismi') return <Minus className="mx-auto size-4 text-warning" aria-label="Kısmen" />
  return <X className="mx-auto size-4 text-ink-3/60" aria-label="Yok" />
}

export function Karsilastirma() {
  useHead(
    {
      title: 'Karşılaştırma',
      description:
        'Excel ve WhatsApp, masaüstü dernek programı ve web sitesi ajansıyla yan yana: hangi işi kim çözüyor.',
    },
    '/karsilastirma',
  )
  return (
    <>
      <SayfaUstu>
        <Section className="pt-0 sm:pt-0">
          <Reveal>
            <Baslik
              seviye="h1"
              eyebrow="Karşılaştırma"
              baslik="Bugün ne kullanıyorsunuz"
              metin="Derneklerin çoğu üç şeyden birini kullanıyor: Excel ve WhatsApp, bir masaüstü dernek programı ya da yalnızca web sitesi yapan bir ajans. Aynı işleri yan yana koyduk. Diğer sütunlar o kategorinin tipik durumunu anlatır; iddia yalnızca kendi ürünümüz için."
            />
          </Reveal>
          <Reveal delay={0.1} className="mt-12 overflow-x-auto">
            <table className="w-full min-w-[720px] border-separate border-spacing-0 text-sm">
              <thead>
                <tr>
                  <th className="sticky left-0 bg-page py-3 pr-4 text-left font-medium text-ink-3">
                    Özellik
                  </th>
                  {SUTUNLAR.map((s, i) => (
                    <th
                      key={s}
                      className={cn(
                        'px-3 py-3 text-center font-semibold',
                        i === SUTUNLAR.length - 1
                          ? 'rounded-t-[var(--radius-card)] bg-brand-subtle text-brand'
                          : 'text-ink',
                      )}
                    >
                      {s}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {SATIRLAR.map((r, ri) => (
                  <tr key={r.ozellik}>
                    <td
                      className={cn(
                        'sticky left-0 bg-page py-3 pr-4 text-ink',
                        ri > 0 && 'border-t border-line',
                      )}
                    >
                      {r.ozellik}
                      {r.not && <span className="block text-xs text-ink-3">{r.not}</span>}
                    </td>
                    {[r.excel, r.masaustu, r.ajans, r.biz].map((v, i) => (
                      <td
                        key={i}
                        className={cn(
                          'px-3 py-3 text-center',
                          ri > 0 && 'border-t border-line',
                          i === 3 && 'bg-brand-subtle/60',
                          i === 3 && ri === SATIRLAR.length - 1 && 'rounded-b-[var(--radius-card)]',
                        )}
                      >
                        <HucreIkon v={v} />
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
            <p className="mt-4 flex flex-wrap gap-4 text-xs text-ink-3">
              <span className="inline-flex items-center gap-1">
                <Check className="size-3.5 text-success" /> var
              </span>
              <span className="inline-flex items-center gap-1">
                <Minus className="size-3.5 text-warning" /> kısmen ya da elle
              </span>
              <span className="inline-flex items-center gap-1">
                <X className="size-3.5" /> yok
              </span>
            </p>
          </Reveal>
        </Section>
      </SayfaUstu>
      <Section className="bg-surface/60">
        <div className="grid gap-8 md:grid-cols-3">
          {[
            {
              b: 'Excel ve WhatsApp',
              m: 'Başlangıçta yeterlidir; iki yıl sonra kimse hangi listenin güncel olduğunu bilmez. Aidat borcu sorulduğunda dosyayı açan kişi aranır. Yedek, yetki ve kayıt yoktur.',
            },
            {
              b: 'Masaüstü dernek programı',
              m: 'Üye ve aidat için iyi çalışır; ama bir bilgisayara bağlıdır, üye kendi borcunu göremez, site ve kongre ayrı yerde durur, kim neyi değiştirdi bilinmez.',
            },
            {
              b: 'Web sitesi ajansı',
              m: 'Site güzeldir; üye listesi yine Excel’dedir. Aidat, başvuru ve etkinlik kaydı siteden panele düşmez, e-postayla gelir ve elle işlenir.',
            },
          ].map((k) => (
            <Reveal key={k.b}>
              <p className="font-semibold text-ink">{k.b}</p>
              <p className="mt-2 text-sm leading-relaxed text-ink-2">{k.m}</p>
            </Reveal>
          ))}
        </div>
      </Section>
      <SonCta
        baslik="Excel’den geçiş ücretsiz."
        metin="Üye ve aidat listenizi yükleyin; ön izleme yapılır, hiçbir satır kaybolmaz. Masaüstü programdan taşıma için kapsamı birlikte belirleriz."
      />
    </>
  )
}
